import React, { useState, useEffect } from "react";

import { Card, CardContent } from "./ui/card";
import twoFaIcon from "../assets/images/settings/2faGraphic.svg";
import { Button } from "./ui/button";
import {
  verify2FA,
  disable2FA,
  setToggle2FaLogin,
} from "../services/settingsService";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../hooks/use-toast";
import { Loader2 } from "lucide-react";
import OtpInput from "react-otp-input";

export default function Disable2FASettings({ setPageNo, twoFaType }) {
  const { toast } = useToast();
  const [otp, setOtp] = useState("");
  const { updateSettings, userProfile, refreshUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [buttonText, setButtonText] = useState("");
  const userId = userProfile?._id;

  const handleChange = (otp) => {
    setOtp(otp);
  };

  useEffect(() => {
    if (twoFaType === "login-on") {
      setButtonText("Enable 2FA Login");
    } else if (twoFaType === "login-off") {
      setButtonText("Disable 2FA Login");
    } else {
      setButtonText("Deactivate 2FA");
    }
  }, [twoFaType]);

  async function verifyDisable2Fa() {
    setIsLoading(true);
    try {
      const twoFAdata = {
        token: otp,
      };
      const apiCall = await verify2FA(twoFAdata);
      if (apiCall.status === 200 && apiCall.data.message === "Code valid") {
        const disCall = await disable2FA(twoFAdata);
        if (disCall.status === 200) {
          setIsLoading(false);

          const newSettings = disCall.data.data;
          updateSettings(newSettings);
          await refreshUser();
          setPageNo(0);
          toast({
            description: "2FA Deactivate Successful",
            variant: "eighty",
          });
        } else {
          setIsLoading(false);
          toast({
            description: "2FA Deactivate Unsusccesful",
            variant: "eighty",
          });
        }
      } else {
        setIsLoading(false);
        toast({
          description: "2FA Verification Error",
          variant: "eighty",
        });
      }
    } catch (err) {
      setIsLoading(false);
      toast({
        description: "2FA Disabling Error",
        variant: "eighty",
      });
    }
  }

  async function toggleLogin2Fa() {
    setIsLoading(true);
    try {
      const twoFAdata = {
        token: otp,
      };
      const apiCall = await verify2FA(twoFAdata);
      if (apiCall.status === 200 && apiCall.data.message === "Code valid") {
        const toggCall = await setToggle2FaLogin(userId);
        if (toggCall.status === 200) {
          setIsLoading(false);

          const newSettings = toggCall.data.data;
          updateSettings(newSettings);
          await refreshUser();
          setPageNo(0);
          if (twoFaType === "login-on") {
            toast({
              description: "2FA Login Activiated",
              variant: "eighty",
            });
          } else {
            toast({
              description: "2FA Login Deactivated",
              variant: "eighty",
            });
          }
        } else {
          setIsLoading(false);
          toast({
            description: "2FA Login Toggle Unsusccesful",
            variant: "eighty",
          });
        }
      } else {
        setIsLoading(false);
        toast({
          description: "2FA Verification Error",
          variant: "eighty",
        });
      }
    } catch (err) {
      setIsLoading(false);
      toast({
        description: "2FA Login Toggle Error",
        variant: "eighty",
      });
    }
  }

  return (
    <>
      <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
        <div className="max-w-3xl w-full">
          <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <CardContent className="px-5 pt-2 py-10">
              <div className="w-full px-4 mb-3 flex justify-center">
                <img src={twoFaIcon} alt="2FA" />
              </div>
              <div className=" text-center">
                <p className="px-4 mb-4 text-[32px] text-brand-primary font-semibold">
                  Enter your 2FA code
                </p>
                <p className="px-4 mb-4 text-[20px] text-text-primary font-normal">
                  Please enter your 6-digit authentication code
                  <br /> from your authenticator app.
                </p>
              </div>
              <div className="columns-1 mb-6">
                <div className="relative w-full px-4 flex justify-center">
                  <OtpInput
                    value={otp}
                    onChange={handleChange}
                    numInputs={6}
                    separator={<span>-</span>}
                    shouldAutoFocus
                    renderInput={(props) => (
                      <input
                        {...props}
                        className="w-12 h-14 text-xl font-bold text-center border-2 border-gray-300 rounded-xl focus:border-purple-500 focus:ring-2 focus:ring-purple-500 hover:border-purple-400 transition-all outline-none"
                      />
                    )}
                    inputStyle={{
                      width: "40px",
                      height: "40px",
                      margin: "0 5px",
                      fontSize: "18px",
                      borderRadius: "12px",
                      border: "1px solid hsl(var(--border))",
                      textAlign: "center",
                    }}
                    focusStyle={{
                      border:
                        "1px solid bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90",
                    }}
                  />
                </div>
              </div>
              <div className="flex justify-center">
                <Button
                  className="bg-gradient-to-r from-purple-500 to-pink-500 text-white py-2 rounded-full w-[50%]"
                  onClick={() => {
                    if (twoFaType === "login-on" || twoFaType === "login-off") {
                      toggleLogin2Fa();
                    } else {
                      verifyDisable2Fa();
                    }
                  }}
                >
                  {isLoading ? (
                    <Loader2 className="animate-spin text-white" />
                  ) : (
                    buttonText
                  )}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}
